import React, { createContext, useContext, useState } from "react";
import EditAssetModal from "./components/assets/EditAssetModal";

const TableProModalsContext = createContext();

export const useTableProModals = () => {
  return useContext(TableProModalsContext);
};

export const TableProModalsProvider = ({ children }) => {
  const [modals, setModals] = useState([]);

  const openModal = modal => {
    setModals([...modals, modal]);
  };

  const closeModal = modal => {
    setModals(modals.filter(m => m !== modal));
  };

  return (
    <TableProModalsContext.Provider value={{ modals, openModal, closeModal }}>
      {children}
      {modals.map(modal => {
        switch (modal.type) {
          case "editAsset":
            return (
              <EditAssetModal
                key={modal.entity.id}
                entity={modal.entity}
                onClose={() => closeModal(modal)}
              />
            );
          default:
            return null;
        }
      })}
    </TableProModalsContext.Provider>
  );
};
